import React from 'react';
import { X } from 'lucide-react';
import { Reveal } from '../Reveal';
import { problemas } from '../../data/content';
export function Problemas() {
  return <section aria-labelledby="problemas-titulo" className="w-full bg-bordo px-4 py-16 sm:px-6 sm:py-20" data-id="element-197" data-mp="3ylt49ye2t24">
      <div className="mx-auto max-w-5xl" data-id="element-198" data-mp="3v4dkfcnwkbqi">
        <Reveal data-id="element-199" data-mp="3q8of0sp7c0ma">
          <h2 id="problemas-titulo" className="text-center font-display text-2xl font-bold leading-snug text-white sm:text-4xl" style={{
          fontSize: "26px"
        }} data-id="element-200" data-mp="3q97xqbmoet1d">
            Si sos profe de telas en Argentina, esto te va a sonar familiar:
          </h2>
        </Reveal>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-4 sm:mt-12" data-id="element-201" data-mp="hrabd9avy8he">
          {problemas.map((problema, index) => <Reveal key={problema} as="li" delay={Math.min(index, 3) * 0.04} className="flex items-start gap-4 rounded-2xl border border-red-400/15 bg-bordo-dark/70 p-5 shadow-sm transition-colors duration-300 hover:bg-bordo-dark sm:items-center sm:gap-5 sm:px-7 sm:py-6" data-id="element-202" data-mp="dpggjhndfyp5" data-mpi={index}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 border-red-400 text-red-400 sm:mt-0 sm:h-8 sm:w-8" aria-hidden="true" data-id="element-203" data-mp="3c3z4f31pgkpz">
                <X className="h-4 w-4 sm:h-[18px] sm:w-[18px]" strokeWidth={3} data-id="element-204" data-mp="334u7201vqxfe" />
              </span>
              <p className="text-sm font-medium leading-relaxed text-white/95 sm:text-lg" data-id="element-205" data-mp="374vzrjpn0gij">{problema}</p>
            </Reveal>)}
        </ul>

        <Reveal delay={0.05} data-id="element-206" data-mp="2y6irr9stfups">
          <p className="mt-12 text-center font-display text-2xl font-bold text-verde sm:text-4xl" style={{
          fontSize: "28px",
          fontWeight: "900"
        }} data-id="element-207" data-mp="2y7lkln9p878c">
            ¿Cuántas clases más vas a improvisar?
          </p>
        </Reveal>
      </div>
    </section>;
}